<template>
  <v-app>
    <div class="overflow-hidden">
      <navbar />
      <router-view />
    </div>
  </v-app>
</template>

<script>
import httpClient from '../httpClient'
// import moment from 'moment'
import Navbar from './Navbar.vue'

export default {
  components: { Navbar },
  metaInfo () {
    return {
      title: this.$route.name,
      titleTemplate: '%s | MoneyAllocate'
    }
  },

  created () {
    httpClient.interceptors.request.use(config => {
      /*
      const expiresAt = moment(localStorage.expiresAt)

      if (expiresAt.isValid() && moment().isBefore(expiresAt)) {
        const diff = moment.duration(expiresAt.diff(moment()))

        if (diff.asHours() < 2 && config.url !== 'auth/refresh') {
          http.post('auth/refresh')
            .then(({ data }) => {
              this.$store.commit('LOGIN', data)
            })
        }
      }
      */

      return config
    })

    httpClient.interceptors.response.use(response => response, error => {
      if (error.response && error.response.status === 401) {
        this.$store.dispatch('home')
      }

      return Promise.reject(error)
    })
  }
}
</script>
